import { useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from '@/components/ui/navigation-menu';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { useI18n } from '../i18n';
import { corporateContent } from '../content/corporateContent';
import './IntroTopNav.css';

export const IntroTopNav = ({ onNavigate }) => {
  const { language, t } = useI18n();
  const copy = corporateContent[language];
  const [open, setOpen] = useState(false);
  const navigating = useRef(false);
  const links = [
    { id: 'capabilities', label: copy.createTitle },
    { id: 'panels', label: t('navOfferings') },
    { id: 'objects', label: t('navSolvedTasks') },
    { id: 'orbital', label: t('orbital') },
    { id: 'studies', label: copy.people.title },
    { id: 'footer', label: t('navContacts') },
  ];
  const navigate = id => {
    navigating.current = true;
    setOpen(false);
    onNavigate(id, false, true);
  };
  return <div className="intro-top-nav corporate-theme" data-testid="intro-top-nav">
    <NavigationMenu className="intro-top-nav-desktop" aria-label={copy.navigation} data-testid="intro-top-nav-desktop">
      <NavigationMenuList className="intro-top-nav-list">
        {links.map(link => <NavigationMenuItem key={link.id}>
          <NavigationMenuLink className="intro-top-nav-link" href={`#${link.id}`} data-testid={`intro-top-nav-link-${link.id}`} onClick={event => {
            if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            navigate(link.id);
          }}>{link.label}</NavigationMenuLink>
        </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>
    <div className="intro-top-nav-mobile">
      <DropdownMenu modal={false} open={open} onOpenChange={value => { if (value) navigating.current = false; setOpen(value); }}>
        <DropdownMenuTrigger asChild>
          <Button type="button" variant="ghost" className="intro-top-nav-trigger" data-testid="intro-top-nav-sections-trigger">{t('sections')}<ChevronDown aria-hidden="true"/></Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" className="intro-top-nav-dropdown corporate-theme" aria-label={copy.navigation} data-testid="intro-top-nav-dropdown" data-lenis-prevent onCloseAutoFocus={event => { if (navigating.current) event.preventDefault(); }}>
          {links.map(link => <DropdownMenuItem key={link.id} className="intro-top-nav-item" data-testid={`intro-top-nav-sections-item-${link.id}`} onSelect={() => navigate(link.id)}>{link.label}</DropdownMenuItem>)}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  </div>;
};
